// Central translation dictionary for AudioFlip.
// Every user-facing string in the app is keyed here.
// Placeholders use {name} interpolation.
export const translations = {
  es: {
    nav: {
      home: "Inicio",
      features: "Características",
      pricing: "Precios",
      login: "Iniciar Sesión",
      signup: "Registrarse",
      toggleLang: "Cambiar idioma",
    },
    hero: {
      kicker: "SaaS · Texto a Audio · IA de voz",
      title_part1: "Transforma tus ",
      title_emphasis: "documentos",
      title_part2: " y libros en audiolibros al instante.",
      subtitle:
        "Sube tus archivos PDF, Word o copia texto directamente. Escucha con voces naturales de inteligencia artificial en cualquier lugar con AudioFlip.",
      pill_neural: "Voces neuronales OpenAI",
      pill_formats: "PDF · DOCX · TXT",
      pill_speed: "Velocidad 0.5x — 2x",
      preview_label: "Vista previa",
      preview_live: "En vivo",
      preview_sample: "Audio muestra · 12s",
      preview_time_start: "00:00",
      preview_time_end: "00:12",
      qr_kicker: "Móvil · Tableta",
      qr_title: "Escanea para abrir AudioFlip en tu teléfono",
    },
    dropzone: {
      extracting: "Extrayendo texto del documento...",
      pasted: "Texto pegado",
      clear: "Limpiar",
      chars_of: "{count} / {max} caracteres",
      minutes: "~{n} min de audio",
      main: "Arrastra tu PDF, Word o pega tu texto aquí",
      limits: "Máx. 50MB · PDF · DOCX · TXT",
      selectFile: "Seleccionar archivo",
      or: "o pega texto",
      manual: "Escribir o pegar texto manualmente →",
    },
    config: {
      step: "01 · Configuración",
      title: "Elige la voz perfecta",
      voiceLabel: "Idioma y Tipo de Voz",
      voicePlaceholder: "Selecciona una voz",
      speedLabel: "Velocidad de Lectura",
      generate: "Generar Audiolibro",
      generating: "Generando...",
      generatingProgress: "Generando {done}/{total} fragmentos...",
      disclaimer: "Sin registro · Descarga MP3 inmediata",
    },
    voices: {
      onyx: "Español — Voz Masculina Natural",
      nova: "Español — Voz Femenina Enérgica",
      echo: "Español — Voz Masculina Calmada",
      shimmer: "Español — Voz Femenina Brillante",
      alloy: "Inglés — Voz Neutra Balanceada",
      fable: "Inglés — Voz Expresiva Narrativa",
      sage: "Inglés — Voz Profesional Sabia",
    },
    toasts: {
      fileTooLarge: "Archivo demasiado grande",
      fileTooLargeDesc: "El límite es de 50MB.",
      badFormat: "Formato no soportado",
      badFormatDesc: "Sube un archivo PDF, DOCX o TXT.",
      extracted: "Texto extraído",
      extractedDesc: "{count} caracteres listos para convertir.",
      extractFailed: "Extracción fallida",
      extractFailedDesc: "Error al extraer el texto",
      noText: "Sin texto",
      noTextDesc: "Sube un archivo o pega texto para generar audio.",
      textTooLong: "Texto muy largo",
      textTooLongDesc: "Máximo {max} caracteres por generación.",
      longJob: "Generación en curso",
      longJobDesc: "Documento largo · {n} fragmentos. Verás el progreso aquí mismo.",
      timeoutError: "Tiempo de espera agotado",
      audioReady: "Audiolibro generado",
      audioReadyDesc: "Reproduce o descarga tu MP3.",
      genFailed: "Generación fallida",
      genFailedDesc: "Error al generar audio",
    },
    features: {
      kicker: "02 · Por qué AudioFlip",
      title_part1: "Diseñado para lectores ",
      title_emphasis: "exigentes",
      title_end: ".",
      subtitle:
        "Pensado desde el primer píxel para que tu tiempo se convierta en escucha, no en fricción. Sube, elige voz y listo.",
      multiFormat_title: "Soporte Multi-formato",
      multiFormat_desc:
        "Convierte PDF, Word (.docx) y texto plano sin perder la estructura. Extracción robusta que preserva párrafos y saltos naturales.",
      voices_title: "Voces Humanizadas",
      voices_desc:
        "Tecnología neuronal de OpenAI con entonación natural, 7 voces distintas en español e inglés. Perfecto para libros y ensayos.",
      download_title: "Descarga Instantánea",
      download_desc:
        "Genera tu MP3 y descárgalo en segundos. Sin registros, sin colas, sin límites de dispositivo. Escucha donde quieras.",
    },
    pricing: {
      kicker: "03 · Precios simples",
      title_part1: "Un plan para cada ",
      title_emphasis: "lector",
      title_end: ".",
      subtitle:
        "Empieza gratis. Sube de plan cuando tu biblioteca lo pida. Cancela cuando quieras — sin letra pequeña.",
      perMonth: "/ mes",
      popular: "Popular",
      explorer_name: "Explorador",
      explorer_tag: "Gratis para siempre",
      explorer_f1: "Hasta 5 audiolibros / mes",
      explorer_f2: "Voces estándar (7 opciones)",
      explorer_f3: "Archivos hasta 10MB",
      explorer_f4: "Descarga MP3 directa",
      explorer_cta: "Empezar gratis",
      author_name: "Autor",
      author_tag: "Ideal para lectores frecuentes",
      author_f1: "Audiolibros ilimitados",
      author_f2: "Voces HD (tts-1-hd)",
      author_f3: "Archivos hasta 50MB",
      author_f4: "Prioridad de procesamiento",
      author_f5: "Biblioteca en la nube",
      author_cta: "Elegir Autor",
      studio_name: "Estudio",
      studio_tag: "Para creadores y editoriales",
      studio_f1: "Todo lo del plan Autor",
      studio_f2: "Clonación de voz personalizada",
      studio_f3: "API para automatización",
      studio_f4: "Marca blanca en reproductor",
      studio_f5: "Soporte dedicado",
      studio_cta: "Hablar con ventas",
    },
    footer: {
      tagline: "Diseñado para lectores",
      privacy: "Privacidad",
      terms: "Términos",
      contact: "Contacto",
    },
    seo: {
      title: "AudioFlip · Documentos a Audiolibros",
      description:
        "Sube PDF, Word o pega texto. Genera audiolibros MP3 con voces IA naturales en segundos.",
      ogTitle: "AudioFlip · Documentos a Audiolibros",
    },
    quota: {
      label: "Cuota diaria · Plan gratuito",
      remaining: "{n} restantes",
      chars: "{used} / {limit} caracteres",
      upgradeAuthor: "Sube a Autor",
      seePlans: "Ver planes",
      queued: "{active}/{max} en cola",
      unavailable: "Cuota no disponible",
    },
    hd: {
      label: "Calidad HD",
      hint: "Voces con mejor pronunciación (recomendado para libros en español)",
      badge: "HD",
    },
    clone: {
      sectionStandard: "Voces estándar",
      sectionMine: "🎤 Mis voces clonadas",
      cloneNew: "➕ Clonar nueva voz",
      modalTitle: "Clonar tu voz",
      modalSubtitle: "Sube una muestra de audio (30-60s) de tu voz hablando en un ambiente silencioso.",
      voiceName: "Nombre de la voz",
      voiceNamePlaceholder: "P. ej. Mi voz narradora",
      audioFile: "Archivo de audio",
      audioHint: "WAV o MP3 · mínimo 30s recomendado · máx 20MB",
      consent: "Confirmo que esta es mi voz o tengo permiso explícito para clonarla.",
      cancel: "Cancelar",
      submit: "Clonar voz ($1 USD)",
      submitting: "Subiendo...",
      processing: "Procesando...",
      processingHint: "HeyGen está entrenando tu voz. Suele tardar 1-3 minutos.",
      ready: "Lista",
      failed: "Falló",
      cloneOk: "Voz clonada",
      cloneOkDesc: "Tu voz \"{name}\" está entrenándose. Aparecerá en el dropdown cuando esté lista.",
      cloneFailed: "Clonación fallida",
      costHint: "Costo: $1 clonación + $0.04/min de audio generado (HeyGen)",
    },
    player: {
      download: "Descargar MP3",
      play: "Reproducir",
      pause: "Pausar",
      close: "Cerrar reproductor",
      rewind: "Retroceder 10s",
      forward: "Avanzar 10s",
      mute: "Silenciar",
    },
  },
  en: {
    nav: {
      home: "Home",
      features: "Features",
      pricing: "Pricing",
      login: "Log In",
      signup: "Sign Up",
      toggleLang: "Switch language",
    },
    hero: {
      kicker: "SaaS · Text to Audio · Voice AI",
      title_part1: "Turn your ",
      title_emphasis: "documents",
      title_part2: " and books into audiobooks instantly.",
      subtitle:
        "Upload your PDF or Word files, or paste text directly. Listen with natural AI voices anywhere with AudioFlip.",
      pill_neural: "OpenAI neural voices",
      pill_formats: "PDF · DOCX · TXT",
      pill_speed: "Speed 0.5x — 2x",
      preview_label: "Preview",
      preview_live: "Live",
      preview_sample: "Sample audio · 12s",
      preview_time_start: "00:00",
      preview_time_end: "00:12",
      qr_kicker: "Mobile · Tablet",
      qr_title: "Scan to open AudioFlip on your phone",
    },
    dropzone: {
      extracting: "Extracting text from document...",
      pasted: "Pasted text",
      clear: "Clear",
      chars_of: "{count} / {max} characters",
      minutes: "~{n} min of audio",
      main: "Drag your PDF, Word, or paste text here",
      limits: "Max 50MB · PDF · DOCX · TXT",
      selectFile: "Select file",
      or: "or paste text",
      manual: "Type or paste text manually →",
    },
    config: {
      step: "01 · Configuration",
      title: "Pick the perfect voice",
      voiceLabel: "Language & Voice Type",
      voicePlaceholder: "Select a voice",
      speedLabel: "Reading Speed",
      generate: "Generate Audiobook",
      generating: "Generating...",
      generatingProgress: "Generating {done}/{total} chunks...",
      disclaimer: "No signup · Instant MP3 download",
    },
    voices: {
      onyx: "Spanish — Natural Male Voice",
      nova: "Spanish — Energetic Female Voice",
      echo: "Spanish — Calm Male Voice",
      shimmer: "Spanish — Bright Female Voice",
      alloy: "English — Balanced Neutral Voice",
      fable: "English — Expressive Narrative Voice",
      sage: "English — Wise Professional Voice",
    },
    toasts: {
      fileTooLarge: "File too large",
      fileTooLargeDesc: "The limit is 50MB.",
      badFormat: "Unsupported format",
      badFormatDesc: "Upload a PDF, DOCX or TXT file.",
      extracted: "Text extracted",
      extractedDesc: "{count} characters ready to convert.",
      extractFailed: "Extraction failed",
      extractFailedDesc: "Failed to extract text",
      noText: "No text",
      noTextDesc: "Upload a file or paste text to generate audio.",
      textTooLong: "Text too long",
      textTooLongDesc: "Maximum {max} characters per generation.",
      longJob: "Generation in progress",
      longJobDesc: "Long document · {n} chunks. You'll see the progress right here.",
      timeoutError: "Timeout exceeded",
      audioReady: "Audiobook ready",
      audioReadyDesc: "Play or download your MP3.",
      genFailed: "Generation failed",
      genFailedDesc: "Audio generation error",
    },
    features: {
      kicker: "02 · Why AudioFlip",
      title_part1: "Built for ",
      title_emphasis: "demanding",
      title_end: " readers.",
      subtitle:
        "Designed from the first pixel so your time turns into listening, not friction. Upload, pick a voice, done.",
      multiFormat_title: "Multi-format Support",
      multiFormat_desc:
        "Convert PDF, Word (.docx), and plain text without losing structure. Robust extraction that preserves paragraphs and natural breaks.",
      voices_title: "Humanized Voices",
      voices_desc:
        "OpenAI neural technology with natural intonation, 7 distinct voices in Spanish and English. Perfect for books and essays.",
      download_title: "Instant Download",
      download_desc:
        "Generate your MP3 and download in seconds. No signup, no queues, no device limits. Listen anywhere.",
    },
    pricing: {
      kicker: "03 · Simple pricing",
      title_part1: "A plan for every ",
      title_emphasis: "reader",
      title_end: ".",
      subtitle:
        "Start free. Upgrade when your library demands it. Cancel anytime — no fine print.",
      perMonth: "/ month",
      popular: "Popular",
      explorer_name: "Explorer",
      explorer_tag: "Free forever",
      explorer_f1: "Up to 5 audiobooks / month",
      explorer_f2: "Standard voices (7 options)",
      explorer_f3: "Files up to 10MB",
      explorer_f4: "Direct MP3 download",
      explorer_cta: "Start free",
      author_name: "Author",
      author_tag: "Ideal for frequent readers",
      author_f1: "Unlimited audiobooks",
      author_f2: "HD voices (tts-1-hd)",
      author_f3: "Files up to 50MB",
      author_f4: "Priority processing",
      author_f5: "Cloud library",
      author_cta: "Choose Author",
      studio_name: "Studio",
      studio_tag: "For creators and publishers",
      studio_f1: "Everything in Author",
      studio_f2: "Custom voice cloning",
      studio_f3: "API for automation",
      studio_f4: "White-label player",
      studio_f5: "Dedicated support",
      studio_cta: "Talk to sales",
    },
    footer: {
      tagline: "Built for readers",
      privacy: "Privacy",
      terms: "Terms",
      contact: "Contact",
    },
    seo: {
      title: "AudioFlip · Documents to Audiobooks",
      description:
        "Upload PDF, Word or paste text. Generate MP3 audiobooks with natural AI voices in seconds.",
      ogTitle: "AudioFlip · Documents to Audiobooks",
    },
    quota: {
      label: "Daily quota · Free plan",
      remaining: "{n} remaining",
      chars: "{used} / {limit} characters",
      upgradeAuthor: "Upgrade to Author",
      seePlans: "See plans",
      queued: "{active}/{max} queued",
      unavailable: "Quota unavailable",
    },
    hd: {
      label: "HD Quality",
      hint: "Voices with better pronunciation (recommended for Spanish books)",
      badge: "HD",
    },
    clone: {
      sectionStandard: "Standard voices",
      sectionMine: "🎤 My cloned voices",
      cloneNew: "➕ Clone new voice",
      modalTitle: "Clone your voice",
      modalSubtitle: "Upload an audio sample (30-60s) of your voice speaking in a quiet room.",
      voiceName: "Voice name",
      voiceNamePlaceholder: "e.g. My narrator voice",
      audioFile: "Audio file",
      audioHint: "WAV or MP3 · 30s minimum recommended · max 20MB",
      consent: "I confirm this is my voice or I have explicit permission to clone it.",
      cancel: "Cancel",
      submit: "Clone voice ($1 USD)",
      submitting: "Uploading...",
      processing: "Processing...",
      processingHint: "HeyGen is training your voice. Usually 1-3 minutes.",
      ready: "Ready",
      failed: "Failed",
      cloneOk: "Voice cloned",
      cloneOkDesc: "Your voice \"{name}\" is training. It will appear in the dropdown once ready.",
      cloneFailed: "Cloning failed",
      costHint: "Cost: $1 cloning + $0.04/min of generated audio (HeyGen)",
    },
    player: {
      download: "Download MP3",
      play: "Play",
      pause: "Pause",
      close: "Close player",
      rewind: "Back 10s",
      forward: "Forward 10s",
      mute: "Mute",
    },
  },
};

/**
 * Resolve a dotted key like "hero.title_part1" in the current locale dict.
 * Falls back to the key itself if missing.
 */
export function resolveKey(dict, key) {
  const parts = key.split(".");
  let node = dict;
  for (const p of parts) {
    if (node && typeof node === "object" && p in node) node = node[p];
    else return key;
  }
  return typeof node === "string" ? node : key;
}

/** Replace {placeholder} tokens with values from params. */
export function interpolate(template, params) {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) =>
    k in params ? String(params[k]) : `{${k}}`
  );
}
